<template>
    <Teleport to="#modals">
        <div v-if="state" class="agora-meeting">
            <AgoraConference :options="{ ...options, namesTick, participantsTick }" @change="handleChange" />
            <button v-if="testButtonState" class="btn btn-primary" type="button" @click="copyAgoraTestData" style="position: fixed;z-index: 999999999999; top:1rem;right: 1rem;">
                Test Verisini Kopyala
            </button>
        </div>
    </Teleport>
</template>
<style scoped>
    .agora-meeting {
        position: fixed;
        z-index: 999999999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: black;
    }
</style>
<script>
    import { reactive, toRefs, computed, watch, onMounted, onBeforeUnmount } from 'vue';
    import { useStore } from "vuex";

    import { appData, C } from '@/helpers/global';

    import { StoreUser } from "@/store/constants";
    import { Enums } from '@/helpers/enums';
    import { Web } from '@/helpers/web';

    import { MeetingService } from "@/services/api/meeting";
    import { MeetingFileService } from '@/services/api/meeting-file';
    import { createMeetingRealtimeService } from "@/services/api/meeting-realtime";
    
    export default {
        name: "AgoraMeeting",
        components: {
            //AgoraConference,
        },
        props: {
            state: {
                type: Boolean,
                default: false,
            },
            detail: {
                type: Object,
                default: null,
            }
        },
        emits: ["change", "update:state", "go-back"],
        setup(props, ctx) {
            const store = useStore();
            const realtime = createMeetingRealtimeService(() => {
                return store.state.user?.token?.accessToken;
            });
            const e = reactive({      
                testButtonState: true,
                token: "",
                rtmToken: "",
                user: computed(() => {
                    if (store.state.user.me) {
                        return store.state.user.me;
                    }
                    return {};
                }),
                state: computed({
                    get() {
                        return props.state;
                    },
                    set(value) {
                        ctx.emit('update:state', value);
                    }
                }),
                namesTick: 0,
                participantsTick: 0,
                options: {
                    appId: "08defc6b0f3740b7a75107737f985753",
                    channelName: null,
                    autoJoin: false,
                    prejoin: true,
                    logActive: true,  // true = loglama aktif, false = loglama pasif
                    presentationUid: "900000002",
                    user: {
                        id: null,
                        name: "",
                        role: null,
                    },
                    startDate: null,
                    studentFiles: [],
                    teacherFiles: [],
                    loadMeetingFiles: () => e.loadFiles(props.detail?.meetingId),
                    getMeetingId: () => props.detail?.meetingId,
                    uploadMeetingFile: (file) => e.uploadMeetingFile(file, props.detail?.meetingId),
                    whiteboardTransport: {
                        send: (payload) => realtime.sendWhiteboard(props.detail.id, payload),
                        onMessage: (handler) => realtime.onWhiteboard(props.detail.id, handler),
                        offMessage: (handler) => realtime.offWhiteboard(props.detail.id, handler),
                    },
                    getToken: ({ channelName }) => {
                         return new Promise((resolve, reject) => {
                            MeetingService.GetToken(channelName, "", (data) => {
                                if (!data) {
                                    reject(new Error("Token alınamadı"));
                                    return;
                                }
                                // data = "userId|token"
                                resolve(data);
                            });
                         });
                    },
                    getPresentationToken: ({ channelName }) => {
                        return new Promise((resolve, reject) => {
                            MeetingService.GetPresentationToken(channelName, (data) => {
                                if (!data) {
                                    reject(new Error("Token alınamadı"));
                                    return;
                                }
                                // data = "userId|token"
                                resolve(data);
                            });
                        });
                    },
                    getRtmToken: ({ channelName, uid }) => {
                         return new Promise((resolve, reject) => {
                            MeetingService.GetRTMToken(channelName, uid, (data) => {
                                if (!data) {
                                    reject(new Error("Token alınamadı"));
                                    return;
                                }
                                // data = "token"
                                resolve(data);
                            });
                        });
                    },
                    resolveName: (uid) => {
                        return realtime.resolveName(uid);
                    },
                },
                close(isBack = false) {
                    e.testButtonState = true;

                    if (isBack) {
                        ctx.emit("go-back");
                    }

                    e.state = false;
                    e.token = "";
                    e.rtmToken = "";
                },
                async handleChange({ type, data }) {
                    switch (type) {
                        case 'token-requested':
                            console.log('Token istendi:', data);
                            break;
                        case 'token-received':
                            console.log('Token alındı:', data);
                            break;
                        case 'joined':
                            e.testButtonState = false;
                            console.log('Kanala katıldı:', data);
                            // Local UID belli oldu, adı map'e bas
                            realtime.setName(data.uid, e.options.user.name);

                            await realtime.joinMeeting({
                                channelName: e.options.channelName,
                                rtcUid: data.uid,
                                displayName: e.options.user.name
                            });
                            break;
                        case 'left':
                            console.log('Kanaldan ayrıldı:', data);
                            await realtime.leaveMeeting();
                            e.close(data?.isBack === true);
                            break;
                        case 'error':
                            console.error('Hata oluştu:', data);
                            // hata olursa realtime kapatmak istersen:
                            // await realtime.disconnect();
                            break;
                        case 'user-joined':
                            console.log('Kullanıcı katıldı:', data);
                            break;
                        case 'user-left':
                            console.log('Kullanıcı ayrıldı:', data);
                            break;
                        case 'connection-state-change':
                            console.log('Bağlantı durumu değişti:', data);
                            break;
                        case 'settings-changed':
                            console.log('Ayarlar değişti:', data);
                            if (data.logActive !== undefined) {
                                e.options.logActive = data.logActive;
                                console.log('Log aktifliği değişti:', data.logActive);
                            }
                            break;
                        case 'whiteboard-toggled':
                            console.log('Beyaz Tahta değişti:', data);
                            break;
                        case 'screen-share-started':
                            console.log('Ekran paylaşımı başladı:', data);
                            break;
                        case 'screen-share-stopped':
                            console.log('Ekran paylaşımı bitti:', data);
                            break;
                        case 'recording-presentation-started':
                            console.log('Recording presentation başladı:', data);
                            await realtime.setMeetingPresentation(e.options.channelName, true);
                            break;
                        case 'recording-presentation-stopped':
                            console.log('Recording presentation bitti:', data);
                            await realtime.setMeetingPresentation(e.options.channelName, false);
                            break;
                        default:
                            console.log('Bilinmeyen event type:', type, data);
                            break;
                    }
                },
                async copyAgoraTestData() {
                    const data = {
                        appId: e.options.appId,
                        channelName: e.options.channelName,
                        userId: e.options.user?.id,
                        userName: e.options.user?.name,
                        role: e.options.user?.role,
                        rtcToken: e.token,
                        rtmToken: e.rtmToken,
                        autoJoin: e.options.autoJoin,
                        prejoin: e.options.prejoin,
                        logActive: e.options.logActive,
                    };
                    const text = JSON.stringify(data, null, 2);
                    await navigator.clipboard.writeText(text);
                },
                loadFiles(meetingId) {
                    if (!Number.isFinite(Number(meetingId)) || Number(meetingId) <= 0) {
                        e.options.studentFiles = [];
                        e.options.teacherFiles = [];
                        return Promise.resolve();
                    }

                    return new Promise((resolve, reject) => {
                        try {
                            MeetingFileService.List(meetingId, (rows) => {
                                try {                                    
                                    const files = Array.isArray(rows) ? rows : [];
                                    e.options.studentFiles = files.filter((file) => C.Int(file.userType) === C.Int(Enums.USER_TYPE.STUDENT));
                                    e.options.teacherFiles = files.filter((file) => C.Int(file.userType) === C.Int(Enums.USER_TYPE.INSTRUCTOR) || C.Int(file.userType) === C.Int(Enums.USER_TYPE.TEACHER));
                                    e.options.studentFiles.forEach(r => {
                                        r.url = Web.Media(r.fileCode);
                                    });
                                    e.options.teacherFiles.forEach(r => {
                                        r.url = Web.Media(r.fileCode);
                                    });
                                    resolve();
                                }
                                catch (error) {
                                    reject(error);
                                }
                            });
                        }
                        catch (error) {
                            reject(error);
                        }
                    });
                },
                async uploadMeetingFile(file, meetingId) {
                    const id = Number(meetingId);
                    if (!Number.isFinite(id) || id <= 0) {
                        throw new Error("Görüşme bilgisi bulunamadı.");
                    }
                    const path = await new Promise((resolve, reject) => {
                        Web.GetBase64(file, (status, path) => {
                            if (status) {
                                resolve(path);
                                return;
                            }
                            reject(new Error("Dosya Base64 formatına dönüştürülemedi."));
                        });
                    });

                    await MeetingFileService.Save({ meetingId: id, path, fileName: file.name });
                },
            });
            onMounted(async () => {
                e.options.channelName = "ch-" + props.detail.id;
                e.options.startDate = props.detail.dayDate;
                const startMs = new Date(e.options.startDate).getTime();

                if (!Number.isFinite(startMs) || Date.now() >= startMs + 50 * 60 * 1000) {
                    e.close();
                    return;
                }

                const me = e.user;
                const fullName = (me && me.fullName) ? String(me.fullName) : "";
                e.options.user.name = fullName;

                switch (me.userType) {
                    case Enums.USER_TYPE.TEACHER:
                    case Enums.USER_TYPE.INSTRUCTOR:
                        e.options.user.role = 2
                        break;
                    case Enums.USER_TYPE.CANDIDATE:
                    case Enums.USER_TYPE.STUDENT:
                    case Enums.USER_TYPE.NULL:
                    default:
                        e.options.user.role = 1;
                        break;
                }
                realtime.setOnNamesChanged(() => {
                    e.namesTick++;
                });
                realtime.setOnParticipantsChanged(() => {
                    e.participantsTick++;
                });
                e.token = await e.options.getToken({
                    channelName: e.options.channelName
                });
                const separatorIndex = e.token.indexOf('|');

                if (separatorIndex >= 0) {
                    const userId = e.token.substring(0, separatorIndex);
                    e.options.user.id = Number(userId);
                }
                e.rtmToken = await e.options.getRtmToken({
                    channelName: e.options.channelName,
                    uid: e.options.user.id
                });
            });            
            onBeforeUnmount(async () => {
                await realtime.disconnect();
            });
            watch(() => e.state, async (newValue) => {
                if (newValue) {
                    try {
                        // Direkt permission iste
                        const stream = await navigator.mediaDevices.getUserMedia({
                            audio: true,
                            video: true
                        });                    
                        // İzin alındı, stream'i temizle
                        stream.getTracks().forEach(track => track.stop());                        
                        // Permission başarılı
                        console.log('✅ Permission granted');                    
                    } catch (error) {
                        // Permission reddedildi
                        console.error('❌ Permission denied:', error);                    
                        // State'i geri false yap
                        emit('update:state', false);
                    }
                }
            });
            return { ...toRefs(e),  };
        }
    }
</script>